import React from 'react';
import { SdmSpacer, SdmTypography, SdmTextButton } from 'components';
import Dialog from '@material-ui/core/Dialog';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import ErrorIcon from '@material-ui/icons/Error';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import { styled } from '@material-ui/core/styles';
import { theme } from 'theme';

const StyledIconButton = styled(IconButton)({
  padding: 5,
});

const InfoDialog = ({
  onClose,
  i18n,
  isSmDown,
  isError,
  customText = false,
  subText = false,
  context = false,
}) => {
  // Functions
  const handleOverflowBody = () => {
    const bodyStatus = document.body.getAttribute('style');
    if (bodyStatus.includes('overflow: hidden')) {
      document.body.style.overflow = 'visible';
      document.body.style.paddingTop = 79;
    }
  };

  const handleClose = () => {
    handleOverflowBody();
    onClose && onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      // maxWidth={300}
      PaperProps={{
        style: {
          paddingRight: 30,
          paddingLeft: 30,
          paddingTop: 80,
          paddingBottom: 50,
        },
      }}
    >
      <div
        tabIndex={0}
        role="button"
        onClick={handleClose}
        style={{
          position: 'absolute',
          top: 24,
          right: 24,
        }}
      >
        <StyledIconButton>
          <CloseIcon fontSize={isSmDown ? 'large' : 'small'} />
        </StyledIconButton>
      </div>
      <Grid container>
        <Grid item xs={12}>
          <SdmTypography
            variant={'h3'}
            style={{ textTransform: 'uppercase' }}
            margin={0}
            textAlign={'center'}
          >
            {i18n.subtitle}
          </SdmTypography>
          <SdmSpacer height={10} />
          <SdmTypography variant={'h1'} margin={0} textAlign={'center'}>
            {i18n.title}
          </SdmTypography>
          <SdmSpacer height={30} />
          <div
            style={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {!isError ? (
              <CheckCircleIcon
                fontSize="large"
                style={{
                  color: '#0C9100',
                }}
              />
            ) : (
              <ErrorIcon
                fontSize="large"
                style={{
                  color: theme.colors.primary.red,
                }}
              />
            )}
          </div>
          <SdmSpacer height={30} />
          <SdmTypography variant={'h1Regular'} margin={0} textAlign={'center'}>
            {isError
              ? i18n.dialogErrorTitle
              : context === 'brand'
              ? customText || i18n.dialogTitleBrand
              : i18n.dialogTitle}
          </SdmTypography>
          <SdmSpacer height={15} />
          <SdmTypography variant={'h2Regular'} margin={0} textAlign={'center'}>
            {isError
              ? i18n.dialogErrorSubtitleOne
              : context === 'brand'
              ? subText || ''
              : i18n.dialogSubtitleOne}
          </SdmTypography>
          {!isError && (
            <>
              <SdmSpacer height={5} />
              <SdmTypography
                variant={'h2Regular'}
                margin={0}
                textAlign={'center'}
              >
                {context === 'brand' ? `` : i18n.dialogSubtitleTwo}
              </SdmTypography>
            </>
          )}
        </Grid>
        <Grid item xs={12}>
          <SdmSpacer height={50} />
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <SdmTextButton
              autoFocus
              text={i18n.buttons.ok}
              height={30}
              style={{ width: 158, height: 50, marginLeft: 10 }}
              variant={'redFill'}
              textVariant={'h4Regular'}
              onClick={handleClose}
            />
          </div>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default InfoDialog;
